<template>
  <div id="layout">
    <nav>
      <v-toolbar class="main-toolbar" dense>
        <img
          src="../../assets/hil-logo.png"
          alt="HiL"
          style="height: 40px"
          class="ml-1 mr-2"
          v-if="$mq !== 'sm'"
        />
        <v-tabs :value="currentTab" class="tabs">
          <v-tab
            icon
            ripple
            v-for="tab in tabs"
            :key="tab.url"
            @click.native="goto(tab.url)"
          >
            <v-icon class="mr-2">{{ tab.icon }}</v-icon>
            <span class="tab-name">{{ tab.name }}</span>
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>

        <div
          v-if="!cordova && $mq !== 'sm'"
          style="font-size: 0.9rem"
          class="mr-2"
        >
          <div>{{ id }}</div>
        </div>
        <v-btn
          icon
          v-if="!cordova"
          @click="goto('/notifications')"
          :depressed="section === 'about'"
        >
          <v-icon>notifications</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="logoutAct"
          v-if="!cordova"
          :depressed="section === 'about'"
        >
          <v-icon>exit_to_app</v-icon>
        </v-btn>
        <v-btn icon @click="goto('/about')" v-else>
          <v-icon>info</v-icon>
        </v-btn>
      </v-toolbar>
    </nav>
    <slot v-if="isLogged" />
    <footer style="margin-top: 80px"></footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "default-layout",
  data: function() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions("user", ["logout", "fetchStatus"]),
    ...mapActions("notifications", ["fetchNotifications"]),
    ...mapActions("autocompletes", ["fetchStaff"]),

    goto(name) {
      this.$router.push(name);
    },

    async logoutAct() {
      try {
        await this.logout();
      } catch (e) {
        // Ignore
      }

      window.location.href = "/";
    }
  },
  async mounted() {
    await this.fetchStatus();
    this.loading = false;
    if (!this.isLogged) {
      this.$router.push({
        name: "home",
        params: { prevRoute: window.location.pathname }
      });
      return;
    }
    if (this.isUser) {
      this.logout();
      return;
    }
    this.fetchNotifications({ email: this.id });
    this.fetchStaff();
  },
  computed: {
    ...mapState("user", ["isLogged", "id"]),
    ...mapGetters("user", ["isSuperAdmin", "isAdminOrSuperAdmin", "isUser"]),
    tabs() {
      return [
        { url: "/sales", icon: "folder", name: "Sales" },
        { url: "/reloc", icon: "folder", name: "Reloc" },
        { url: "/hosts", icon: "house", name: "Biens" },
        { url: "/prospects", icon: "business", name: "B2B" },
        { url: "/announcements", icon: "shopping_basket", name: "B2C" },
        { url: "/billing", icon: "euro_symbol", name: "Règlements" },
        { url: "/help", icon: "help", name: "Aide" },
        ...(this.isSuperAdmin
          ? [{ url: "/admin", icon: "settings_applications", name: "Admin" }]
          : []),
        { url: "/compta", icon: "folder", name: "Compta" },
        ...(this.isAdminOrSuperAdmin
          ? [{ url: "/dashboard", icon: "stacked_bar_chart", name: "Pilotage" }]
          : [])
      ];
    },
    section() {
      return this.$route.meta.section;
    },
    currentTab() {
      if (this.$route.meta.tab !== undefined) {
        return this.$route.meta.tab;
      }
      return this.tabs.findIndex(tab => tab.url === this.$route.path);
    },
    cordova() {
      return process.env.CORDOVA_PLATFORM;
    }
  }
};
</script>
<style scoped>
.main-toolbar {
  overflow-x: auto;
}

.theme--dark.main-toolbar {
  background-color: #424242 !important;
}

@media screen and (max-width: 450px) {
  .main-toolbar >>> .v-toolbar__content {
    padding-left: 0;
  }
}

@media screen and (max-width: 640px) {
  .tab-name {
    display: none;
  }

  .tabs .v-icon {
    margin-right: 0px !important;
  }
}
</style>
